import React, { memo, useCallback, useEffect, useMemo } from 'react'
import { Spin } from 'antd'
import PropTypes from 'prop-types'

import { showErrorNotification } from '../../../core/helpers'
import { useQueryParams } from '../../../core/hooks'

import { PAGINATION } from '../../../common/constants'

import { useUnknownWordsQuery } from '../../hooks'
import {
  StyledUnknownWordsModal,
  StyledUnknownWordsModalCloseIcon,
} from '../styled'

import UnknownWordsModalBody from './unknown-words-modal-body'
import UnknownWordsModalHeader from './unknown-words-modal-header'

const UnknownWordsModal = ({ menuCurationTaskId }) => {
  const {
    unknownWordsCurrentPage = PAGINATION.DEFAULT_PAGE,
    unknownWordsPageSize = PAGINATION.DEFAULT_PAGE_SIZE,
    sortUnknownWordsBy,
    setQueryParams,
  } = useQueryParams()

  const { filters, sorters, pagination } = useMemo(
    () => ({
      filters: {
        menuCurationTaskId,
      },
      sorters: {
        sortBy: sortUnknownWordsBy,
      },
      pagination: {
        pageSize: unknownWordsPageSize,
        currentPage: unknownWordsCurrentPage,
      },
    }),
    [
      menuCurationTaskId,
      sortUnknownWordsBy,
      unknownWordsCurrentPage,
      unknownWordsPageSize,
    ],
  )

  const {
    isLoading,
    error,
    data: { result: unknownWords } = {},
  } = useUnknownWordsQuery(filters, sorters, pagination)

  useEffect(() => {
    if (error) {
      showErrorNotification({
        title: 'Failed to get U.W. completness counts',
        description: error,
      })
    }
  }, [error])

  const handleClose = useCallback(
    () =>
      setQueryParams({
        isUnknownWordsModalShown: null,
        sortUnknownWordsBy: null,
        unknownWordsCurrentPage: null,
        unknownWordsPageSize: null,
      }),
    [setQueryParams],
  )

  return (
    <StyledUnknownWordsModal
      closeIcon={<StyledUnknownWordsModalCloseIcon />}
      wrapClassName="unknown-words-modal"
      title={isLoading ? 'Loading Words...' : <UnknownWordsModalHeader />}
      width="calc(100vw - 40px)"
      visible
      footer={null}
      onCancel={handleClose}
    >
      {isLoading ? (
        <Spin />
      ) : (
        <UnknownWordsModalBody
          onClose={handleClose}
          unknownWords={unknownWords}
        />
      )}
    </StyledUnknownWordsModal>
  )
}

UnknownWordsModal.propTypes = {
  menuCurationTaskId: PropTypes.string.isRequired,
}

export default memo(UnknownWordsModal)
